/**
 * 404 Not Found page.
 * Replaces the previous catch-all <Navigate to="/" />, which made stale or
 * unimplemented links look like a logout/redirect. Preserves the user's auth
 * session.
 */
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Compass, ArrowLeft, Home } from "lucide-react";
import { useAuth, useLanguage } from "@/context/AppContext";

const NotFoundPage = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const { t } = useLanguage();

  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 text-white"
      style={{ background: "radial-gradient(ellipse at top, #0F2557 0%, #0A1A3E 60%, #050B23 100%)" }}
      data-testid="not-found-page"
    >
      <div className="max-w-md w-full text-center">
        <div className="mx-auto w-20 h-20 rounded-full bg-white/10 flex items-center justify-center mb-6">
          <Compass className="w-10 h-10 text-[#60a5fa]" />
        </div>
        <div className="text-7xl font-extrabold text-white/80 mb-2 tracking-tight">404</div>
        <h1 className="text-2xl font-bold mb-2">{t("notFoundTitle") || "Page not found"}</h1>
        <p className="text-blue-100/70 mb-8 text-sm">
          {t("notFoundBody") ||
            "The page you're looking for doesn't exist or has been moved. You are still signed in."}
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            variant="outline"
            className="bg-white/5 border-white/20 text-white hover:bg-white/10"
            onClick={() => navigate(-1)}
            data-testid="not-found-back-btn"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {t("goBack") || "Go back"}
          </Button>
          <Button
            className="bg-[#0044CC] hover:bg-[#0055EE] text-white"
            onClick={() => navigate(user ? "/dashboard" : "/")}
            data-testid="not-found-home-btn"
          >
            <Home className="w-4 h-4 mr-2" />
            {user ? (t("backToDashboard") || "Back to dashboard") : (t("backHome") || "Back home")}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
